import api from '@/api';
import { ref } from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';
import usePlan from '@/compositions/accounting/usePlan';
import useSubscription from '@/compositions/accounting/useSubscription';

const priceUpgrade = ref(null);
const quotasUpgrade = ref(null);
const calculatingUpgrade = ref(null);

export default function useUpgradePlan() {
  const { isExpired } = useSubscription();

  async function calculateUpgrade(planId) {
    const route = isExpired.value ? 'accounting/plan/renew/calculate' : 'accounting/plan/upgrade/calculate';
    const response = await api.post(route, {
      planId,
    });

    const { price, quotas, calculating } = response.data;

    priceUpgrade.value = price;
    quotasUpgrade.value = quotas;
    calculatingUpgrade.value = calculating;
  }

  async function fetchData() {
    const { fetch } = useAccount();
    const { fetchAll } = usePlan();
    await Promise.all([fetch(), fetchAll()]);
  }

  return {
    calculateUpgrade,
    priceUpgrade,
    quotasUpgrade,
    calculatingUpgrade,
    fetchData,
  };
}
